import { ApiBaseService, type ApiServiceConfig } from "./ApiBaseService";

/**
 * This service is used to manage user authentications.
 *
 * [it handles]:
 * - user logins
 * - user registrations
 * - password resets
 * - email verification
 * - authenticated user retrieval
 */
export default class AuthAccountService extends ApiBaseService {
    constructor(config: ApiServiceConfig) {
        super(config);
    }

    async swap(
        id: string,
        body?: {
            role?: string;
        },
    ): Promise<boolean> {
        try {
            

            await this.request(
                this.route("api.auth.account.swap", "/auth/account/{id}/swap", {
                    id,
                }),
                {
                    method: "post",
                    body,
                },
            );

            return true;
        } catch {
            return false;
        }
    }
}
